"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapRandomKey = void 0;
function mapRandomKey(nextCart) {
  if (nextCart.items.length > 0) {
    for (var _i = 0, _a = nextCart.items; _i < _a.length; _i++) {
      var item = _a[_i];
      item.random = Math.random();
    }
  }
}
exports.mapRandomKey = mapRandomKey;